/* STH Extras v4 - Amazon Mega Menu + Sidebar + Back to Top + Smart Sticky */

// Back to Top
(function(){
  var btn=document.createElement('button');
  btn.innerHTML='&#8593;';
  btn.setAttribute('aria-label','Back to top');
  btn.style.cssText='position:fixed;bottom:24px;right:24px;width:44px;height:44px;border-radius:50%;background:#2A2724;color:#F5F1EA;border:none;font-size:20px;cursor:pointer;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s;z-index:90;box-shadow:0 2px 8px rgba(42,39,36,.15)';
  document.body.appendChild(btn);
  btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
  window.addEventListener('scroll',function(){
    btn.style.opacity=window.pageYOffset>600?'1':'0';
    btn.style.visibility=window.pageYOffset>600?'visible':'hidden';
  },{passive:true});
})();

// Smart sticky header
(function(){
  var h=document.querySelector('.shopify-section-group-header-group');
  if(!h)return;
  var last=0;
  window.addEventListener('scroll',function(){
    var c=window.pageYOffset;
    if(c<=80){h.classList.remove('header-hidden');return}
    if(c>last)h.classList.add('header-hidden');
    else h.classList.remove('header-hidden');
    last=c;
  },{passive:true});
})();

// ============================================================
// AMAZON-STYLE MEGA MENU (desktop hover flyout + mobile drawer)
// ============================================================
(function(){
  var categories=[
    {name:'Best Sellers',url:'/collections/best-sellers',icon:'🏆',subs:[
      {name:'Top 100',url:'/collections/best-sellers'},
      {name:'New Arrivals',url:'/collections/new-arrivals'},
      {name:'Trending Now',url:'/collections/best-sellers'}
    ]},
    {name:'Beauty & Personal Care',url:'/collections/beauty-personal-care-1',icon:'✨',subs:[
      {name:'Skincare',url:'/collections/beauty-personal-care-1?q=skincare'},
      {name:'K-Beauty',url:'/collections/beauty-personal-care-1?q=korean'},
      {name:'Hair Care',url:'/collections/beauty-personal-care-1?q=hair'},
      {name:'Makeup',url:'/collections/beauty-personal-care-1?q=makeup'},
      {name:'Body Care',url:'/collections/beauty-personal-care-1?q=body'},
      {name:'Nail Care',url:'/collections/beauty-personal-care-1?q=nail'},
      {name:'Fragrances',url:'/collections/beauty-personal-care-1?q=perfume'}
    ]},
    {name:'Wellness & Supplements',url:'/collections/wellness-supplements',icon:'💊',subs:[
      {name:'Vitamins',url:'/collections/wellness-supplements?q=vitamin'},
      {name:'Probiotics',url:'/collections/wellness-supplements?q=probiotic'},
      {name:'Omega-3 & Fish Oil',url:'/collections/wellness-supplements?q=omega'},
      {name:'Magnesium',url:'/collections/wellness-supplements?q=magnesium'},
      {name:'Collagen',url:'/collections/wellness-supplements?q=collagen'},
      {name:'Hydration',url:'/collections/wellness-supplements?q=hydration'}
    ]},
    {name:'Home & Kitchen',url:'/collections/home-kitchen-essentials',icon:'🏠',subs:[
      {name:'Kitchen Gadgets',url:'/collections/home-kitchen-essentials?q=kitchen'},
      {name:'Organization',url:'/collections/home-kitchen-essentials?q=organizer'},
      {name:'Cleaning',url:'/collections/home-kitchen-essentials?q=cleaning'},
      {name:'Storage',url:'/collections/home-kitchen-essentials?q=storage'},
      {name:'Decor',url:'/collections/home-kitchen-essentials?q=decor'}
    ]},
    {name:'Electronics & Gadgets',url:'/collections/electronics-gadgets',icon:'📱',subs:[
      {name:'Headphones & Audio',url:'/collections/electronics-gadgets?q=headphone'},
      {name:'Chargers & Cables',url:'/collections/electronics-gadgets?q=charger'},
      {name:'Smart Home',url:'/collections/electronics-gadgets?q=smart'},
      {name:'Cameras',url:'/collections/electronics-gadgets?q=camera'},
      {name:'TV Remotes',url:'/collections/electronics-gadgets?q=remote'}
    ]},
    {name:'Pet Supplies',url:'/collections/pet-supplies',icon:'🐾',subs:[
      {name:'Dog',url:'/collections/pet-supplies?q=dog'},
      {name:'Cat',url:'/collections/pet-supplies?q=cat'},
      {name:'Bird',url:'/collections/pet-supplies?q=bird'},
      {name:'Pet Food',url:'/collections/pet-supplies?q=food'},
      {name:'Pet Toys',url:'/collections/pet-supplies?q=toy'}
    ]},
    {name:'Baby & Kids',url:'/collections/baby-kids-essentials-1',icon:'👶',subs:[
      {name:'Feeding',url:'/collections/baby-kids-essentials-1?q=feeding'},
      {name:'Diapering',url:'/collections/baby-kids-essentials-1?q=diaper'},
      {name:'Baby Gear',url:'/collections/baby-kids-essentials-1?q=gear'},
      {name:'Bath & Skin',url:'/collections/baby-kids-essentials-1?q=bath'},
      {name:'Safety',url:'/collections/baby-kids-essentials-1?q=safety'}
    ]},
    {name:'Food & Beverages',url:'/collections/food-beverages',icon:'🍽️',subs:[
      {name:'Snacks',url:'/collections/food-beverages?q=snack'},
      {name:'Drinks',url:'/collections/food-beverages?q=drink'},
      {name:'Coffee & Tea',url:'/collections/food-beverages?q=coffee'},
      {name:'Organic',url:'/collections/food-beverages?q=organic'}
    ]},
    {name:'Entertainment',url:'/collections/entertainment',icon:'🎵',subs:[
      {name:'Vinyl Records',url:'/collections/entertainment?q=vinyl'},
      {name:'Gaming',url:'/collections/entertainment?q=gaming'},
      {name:'Musical Instruments',url:'/collections/entertainment?q=guitar'}
    ]},
    {name:'Books & Media',url:'/collections/books-media',icon:'📚',subs:[
      {name:'Fiction',url:'/collections/books-media'},
      {name:'Non-Fiction',url:'/collections/books-media'},
      {name:'Comics & Manga',url:'/collections/books-media?q=comic'},
      {name:'Calendars',url:'/collections/books-media?q=calendar'}
    ]},
    {name:'Sports & Outdoors',url:'/collections/sports-outdoors',icon:'⚽',subs:[
      {name:'Fitness',url:'/collections/sports-outdoors?q=fitness'},
      {name:'Yoga',url:'/collections/sports-outdoors?q=yoga'},
      {name:'Water Bottles',url:'/collections/sports-outdoors?q=bottle'}
    ]},
    {name:'Automotive',url:'/collections/all?q=car',icon:'🚗',subs:[
      {name:'Car Care',url:'/collections/all?q=car+care'},
      {name:'Accessories',url:'/collections/all?q=car+accessories'},
      {name:'Sun Shades',url:'/collections/all?q=sun+shade'}
    ]}
  ];

  // ---- DESKTOP: Inject mega menu into nav bar ----
  function buildDesktopMegaMenu(){
    var nav=document.querySelector('nav[aria-label="Menu"] > ul, nav.dropdown > ul, .menubar ul');
    if(!nav) return;

    // Create "All Departments" trigger
    var allDept=document.createElement('li');
    allDept.id='sth-mega-trigger';
    allDept.style.cssText='position:relative;cursor:pointer;display:flex;align-items:center;gap:4px';
    allDept.innerHTML='<a href="#" style="color:#FFF!important;font-weight:600!important;font-size:13px!important;display:flex;align-items:center;gap:6px;padding:8px 14px!important" onclick="return false">☰ All Departments</a>';

    // Create mega dropdown
    var mega=document.createElement('div');
    mega.id='sth-mega-dropdown';
    mega.style.cssText='position:absolute;top:100%;left:0;display:none;background:#FFF;border:1px solid #DDD;box-shadow:0 4px 20px rgba(0,0,0,.25);z-index:1000;min-width:260px;overflow:visible;border-radius:0 0 4px 4px';

    categories.forEach(function(cat){
      var row=document.createElement('div');
      row.className='sth-mega-row';
      row.style.cssText='position:relative';

      var link=document.createElement('a');
      link.href=cat.url;
      link.style.cssText='display:flex;align-items:center;gap:10px;padding:10px 16px;color:#111;font-family:Inter,sans-serif;font-size:13px;text-decoration:none;border-bottom:1px solid #F5F5F5;transition:background .1s';
      link.innerHTML='<span style="font-size:16px;width:22px;text-align:center">'+cat.icon+'</span><span style="flex:1">'+cat.name+'</span><span style="color:#999;font-size:11px">›</span>';

      // Sub-menu flyout
      if(cat.subs && cat.subs.length){
        var flyout=document.createElement('div');
        flyout.className='sth-mega-flyout';
        flyout.style.cssText='position:absolute;top:0;left:100%;display:none;background:#FFF;border:1px solid #DDD;box-shadow:4px 4px 16px rgba(0,0,0,.15);min-width:220px;z-index:1001;border-radius:0 4px 4px 0';

        var flyHead=document.createElement('div');
        flyHead.style.cssText='padding:10px 16px;font-weight:700;font-size:14px;color:#0F1111;border-bottom:2px solid #F90;font-family:Inter,sans-serif';
        flyHead.textContent=cat.name;
        flyout.appendChild(flyHead);

        cat.subs.forEach(function(sub){
          var subLink=document.createElement('a');
          subLink.href=sub.url;
          subLink.style.cssText='display:block;padding:8px 16px;color:#111;font-family:Inter,sans-serif;font-size:13px;text-decoration:none;transition:background .1s';
          subLink.textContent=sub.name;
          subLink.addEventListener('mouseenter',function(){this.style.background='#F0F0F0'});
          subLink.addEventListener('mouseleave',function(){this.style.background='transparent'});
          flyout.appendChild(subLink);
        });

        row.appendChild(flyout);

        row.addEventListener('mouseenter',function(){
          this.querySelector('a').style.background='#F0F0F0';
          this.querySelector('.sth-mega-flyout').style.display='block';
        });
        row.addEventListener('mouseleave',function(){
          this.querySelector('a').style.background='transparent';
          this.querySelector('.sth-mega-flyout').style.display='none';
        });
      } else {
        link.addEventListener('mouseenter',function(){this.style.background='#F0F0F0'});
        link.addEventListener('mouseleave',function(){this.style.background='transparent'});
      }

      row.appendChild(link);
      mega.appendChild(row);
    });

    // "Browse all" at bottom
    var browseAll=document.createElement('a');
    browseAll.href='/collections/all';
    browseAll.style.cssText='display:block;padding:12px 16px;color:#C97B5C;font-family:Inter,sans-serif;font-size:13px;font-weight:600;text-decoration:none;border-top:2px solid #EEE;background:#FAFAFA';
    browseAll.textContent='See all products →';
    mega.appendChild(browseAll);

    allDept.appendChild(mega);

    // Show/hide on hover
    var hideTimer;
    allDept.addEventListener('mouseenter',function(){
      clearTimeout(hideTimer);
      mega.style.display='block';
    });
    allDept.addEventListener('mouseleave',function(){
      hideTimer=setTimeout(function(){mega.style.display='none'},200);
    });

    // Insert as first item
    nav.insertBefore(allDept,nav.firstChild);
  }

  // ---- MOBILE: Keep sidebar drawer ----
  function buildMobileSidebar(){
    var overlay=document.createElement('div');
    overlay.id='sth-catalog-overlay';
    overlay.style.cssText='position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);z-index:999;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s;cursor:pointer';
    document.body.appendChild(overlay);

    var sidebar=document.createElement('div');
    sidebar.id='sth-catalog-sidebar';
    sidebar.style.cssText='position:fixed;top:0;left:-360px;width:340px;max-width:85vw;height:100%;background:#FFF;z-index:1000;overflow-y:auto;transition:left .3s ease;box-shadow:4px 0 20px rgba(0,0,0,.2)';

    var header=document.createElement('div');
    header.style.cssText='background:#232F3E;color:#FFF;padding:14px 20px;font-family:Inter,sans-serif;font-size:16px;font-weight:600;display:flex;align-items:center;justify-content:space-between';
    header.innerHTML='<span>☰ All Departments</span><button id="sth-sidebar-close" style="background:none;border:none;color:#FFF;font-size:24px;cursor:pointer;padding:0;line-height:1">&times;</button>';
    sidebar.appendChild(header);

    var list=document.createElement('div');
    list.style.cssText='padding:8px 0';
    categories.forEach(function(cat){
      // Main category
      var catDiv=document.createElement('div');

      var a=document.createElement('a');
      a.href=cat.url;
      a.style.cssText='display:flex;align-items:center;gap:12px;padding:12px 20px;color:#111;font-family:Inter,sans-serif;font-size:14px;font-weight:600;text-decoration:none;border-bottom:1px solid #F0F0F0';
      a.innerHTML='<span style="font-size:18px">'+cat.icon+'</span><span>'+cat.name+'</span>';
      catDiv.appendChild(a);

      // Sub-categories
      if(cat.subs && cat.subs.length){
        cat.subs.forEach(function(sub){
          var subA=document.createElement('a');
          subA.href=sub.url;
          subA.style.cssText='display:block;padding:8px 20px 8px 52px;color:#555;font-family:Inter,sans-serif;font-size:13px;text-decoration:none;border-bottom:1px solid #FAFAFA';
          subA.textContent=sub.name;
          catDiv.appendChild(subA);
        });
      }

      list.appendChild(catDiv);
    });
    sidebar.appendChild(list);

    var browseAll=document.createElement('a');
    browseAll.href='/collections/all';
    browseAll.style.cssText='display:block;padding:16px 20px;color:#C97B5C;font-family:Inter,sans-serif;font-size:14px;font-weight:500;text-decoration:none;border-top:2px solid #F0F0F0;margin-top:8px';
    browseAll.textContent='Browse all products →';
    sidebar.appendChild(browseAll);

    document.body.appendChild(sidebar);

    function openSidebar(){
      sidebar.style.left='0';
      overlay.style.opacity='1';
      overlay.style.visibility='visible';
      document.body.style.overflow='hidden';
    }
    function closeSidebar(){
      sidebar.style.left='-360px';
      overlay.style.opacity='0';
      overlay.style.visibility='hidden';
      document.body.style.overflow='';
    }
    overlay.addEventListener('click',closeSidebar);
    document.addEventListener('click',function(e){
      if(e.target.id==='sth-sidebar-close')closeSidebar();
    });

    // Hook "Catalog" nav link + mobile menu icon
    var catalogLinks=document.querySelectorAll('nav a');
    catalogLinks.forEach(function(a){
      if(a.textContent.trim().toLowerCase().indexOf('catalog')>-1){
        a.addEventListener('click',function(e){
          e.preventDefault();
          openSidebar();
        });
      }
    });

    // Also hook "All Departments" on mobile
    var megaTrigger=document.getElementById('sth-mega-trigger');
    if(megaTrigger && window.innerWidth<768){
      megaTrigger.addEventListener('click',function(e){
        e.preventDefault();
        openSidebar();
      });
    }
  }

  // Init
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){
      buildDesktopMegaMenu();
      buildMobileSidebar();
    });
  } else {
    buildDesktopMegaMenu();
    buildMobileSidebar();
  }
})();
